export const selectProfileInfo = (id) => ({
  type: `SELECT_PROFILE_INFO`,
  id,
});

export default selectProfileInfo;
